export const STRINGS = {
  openMenu: "Abrir menu",
  closeMenu: "Fechar menu",
  unitsPanelTitle: "Unidades",
  backToMenu: "Voltar ao menu",
  closeMenuBackdrop: "Fechar menu",
  mainNavigation: "Navegação principal",
  megaMenuPanel: (itemName: string) => `Itens de ${itemName}`,
  megaMenuLoading: "Carregando itens",
  cardCtaDefault: "Explore",
  seeAllDefault: (itemName: string) => `Ver todos · ${itemName}`,
  logoFallbackAlt: (index: 1 | 2) => `Logo ${index}`,
  logoLinkLabel: (index: 1 | 2) => `Link da logo ${index}`,
  buttonFallbackLabel: (index: number) => `Botão ${index + 1}`,
} as const;
